// zakazky_plocha_v1 (20. 10. 2026): jeden rad nad prácou, KPI do filtrov
// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 3 miest
// ZakazkyView — Matrix v2 master-detail (sek. 56) — Task #8 MVP
// LAYOUT: vľavo úzky zoznam zákaziek (420 px), vpravo detail vybranej
// Tabs v detaile: Info / ChangeOrder / Audit (ostatné placeholder ROADMAP)
//
// ÚSTAVA:
// - sek. 10.1 — Stavy: planned=Dohodnuté 🔵 / active=Prebieha 🟢 / done=Ukončené 🔴
// - sek. 12.0 bod 3 — Form → Confirm 2-fáza
// - sek. 13.4 — Duplicate guard (zakazka_code, name)
// - sek. 32 — Change Order workflow (zákazka sa nedá ukončiť ak má neschválené CO)
// - sek. 53.7 — useLock pri Edit
// - sek. 56 — Master-detail (↑↓ = select, Enter / 2× klik = Edit, "+ Nová" zelená)
// - sek. 21.15 — Farby: zelená pridať, červená zmazať, modrá nav, amber súčet

import HelpHint from '../components/HelpHint.jsx'
import { NesparovaneFA } from '../components/PrijmyZakazky.jsx'   // PRIJMY_ZAKAZKA_V1: FVSP z MKsoftu bez zákazky v Matrixe   // hinty_v1: obrazovka nemala ani jednu nápovedu
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'
import useLiveRefresh from '../hooks/useLiveRefresh.js'
import NavIcon from '../components/NavIcon.jsx'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext.jsx'
import { fetchAuth, fetchAuthJSON } from '../auth/fetchAuth.js'
import { useBreadcrumb } from '../components/Layout.jsx'
import { Btn, BtnAdd, BtnNav, BtnGhost, BtnDanger } from '../components/Btn.jsx'
import { Input, NumberInput, Textarea } from '../components/Input.jsx'
import { Modal } from '../components/Modal.jsx'
import { Table, THead, TBody, TR, TH, TD } from '../components/Table.jsx'
import { useToast } from '../components/Toast.jsx'
import { useShortcuts } from '../hooks/useShortcuts.js'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { usePositionMemory } from '../hooks/usePositionMemory.js'
import { useDirtyState } from '../hooks/useDirtyState.js'
import { useLock } from '../hooks/useLock.js'
import { COLORS, TYPO, SPACE, RADIUS, SK, todayLocal, hladaj } from '../theme.js'
import { KpiCard, FilterChips, SearchableSelect } from '../components/Ui.jsx'
import ParovanieMKsoft, { StitokMKsoft, MksoftParovanieOkno } from '../components/ParovanieMKsoft.jsx'
import NovaZakazkaV3 from '../components/NovaZakazkaV3.jsx'
import VyberPartnera, { moznostPartnera } from '../components/VyberPartnera.jsx'   // PARTNER_KONTROLA_V1: jeden výber partnera s oknom nového partnera (0.J, 56.11)
import AdresaBunky from '../components/AdresaBunky.jsx'   // CP_OTVOR_V1: miesto stavby v bunkách aj v náhľade zamknutej zákazky
import { adresaSloz, adresaRozlozStavba } from '../lib/adresa.js'
import EditZakazkaV3 from '../components/EditZakazkaV3.jsx'   // Upraviť zákazku na spoločnom FormularV3 (29. 9. 2026)
import { TerminyAkciaOkno } from '../components/TerminyZakazky.jsx'   // ukoncit_v1: Začať/Ukončiť/Otvoriť len cez Termíny (23.2.A)   // Nová zákazka V3 — 3 kroky (28. 9. 2026, ústava 131 + 23.3.A)   // párovanie s MKsoftom (Mirko 27. 9. 2026, mockup OK)
import { DetailPane } from './ProjectDetail.jsx'
import RowMenu from '../components/RowMenu.jsx'
import ExportMenu from '../components/ExportMenu.jsx'
import { confirmLeave } from '../hooks/unsavedGuard.js'

// Stavy zákazky — mapping podľa ústavy 10.1
const STATUSES = [
  { key: 'all',     label: 'Všetky',    color: COLORS.muted, bg: 'transparent' },
  { key: 'planned', label: 'Dohodnuté', color: COLORS.nav,   bg: COLORS.navBg,    icon: '' },
  { key: 'active',  label: 'Prebieha',  color: COLORS.add,   bg: COLORS.addBg,    icon: '' },
  { key: 'done',    label: 'Ukončené',  color: COLORS.remove,bg: COLORS.removeBg, icon: '' },
  { key: 'nesparovane', label: 'Nespárované', color: '#b91c1c', bg: '#fee2e2', icon: '' },   // bez MKsoft čísla
  // zakazky_ui_v1 (13. 10. 2026): archív mal vlastný štítok. Bez neho padal na náhradu STATUSES[1]
  // a archivovaná zákazka sa v zozname tvárila ako „Dohodnuté", hoci okno Upraviť pri nej písalo „Archív".
  { key: 'archived', label: 'Archív', color: COLORS.muted, bg: COLORS.bgSoft, icon: '' }
]

// zakazky_plocha_v1: krátka suma do filtra (3,29 mil € / 201 tis € / 1 234,56 €)
const kratkaSuma = (n) => { n = Number(n) || 0; if (Math.abs(n) >= 1e6) return (n / 1e6).toFixed(2).replace('.', ',') + ' mil €'; if (Math.abs(n) >= 1e4) return Math.round(n / 1e3) + ' tis €'; return SK.eur(n) }

const SEGMENTS = [
  { key: 'firma', label: 'Firma' },
  { key: 'rd',    label: 'RD (rodinný dom)' }
]

const TYPES = [
  'omietky','potery','maliarske','komplet','iné'
]

// Status badge helper
const statusBadge = (s) => {
  // zakazky_ui_v1: neznámy stav sa už nevydáva za „Dohodnuté" — ukáže sa tak, ako je zapísaný.
  const cfg = STATUSES.find(x => x.key === (s || 'planned')) || { label: String(s || '—'), color: COLORS.muted, bg: COLORS.bgSoft }
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '1px 6px',
      fontSize: TYPO.sizes.xs,
      fontWeight: TYPO.weights.semibold,
      color: cfg.color,
      background: cfg.bg,
      border: `1px solid ${cfg.color}`,
      borderRadius: RADIUS.full,
      whiteSpace: 'nowrap'
    }}>{cfg.label}</span>
  )
}

export default function ZakazkyView() {
  const navigate = useNavigate()
  const { id: selectedId } = useParams()
  const { user } = useAuth()
  const toast = useToast()
  const { setTrail } = useBreadcrumb()

  // Data
  const [items, setItems] = useState([])
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(true)

  // UI state
  const pos = usePositionMemory('zakazky')
  const listRef = useRef(null)
  const [search, setSearch] = useState(pos.filter?.search || '')
  const [filterStatus, setFilterStatus] = useState(pos.filter?.status || 'all')
  const [parovat, setParovat] = useState(null)
  const [vratit, setVratit] = useState(null)
  const [terminyAkcia, setTerminyAkcia] = useState(null)   // ⋮ Začať / Ukončiť / Otvoriť cez Termíny   // lišta Vrátiť po založení zákazky (2 min)   // zákazka, pre ktorú je otvorené okno Spárovať s MKsoftom (⋮ aj karta = ten istý handler)
  const [mkZname, setMkZname] = useState(new Set())   // čísla známe v MKsofte (žltý štítok, keď číslo v MKsofte nie je)
  useEffect(() => { fetchAuthJSON('/api/mksoft-zakazky').then(j => setMkZname(new Set((j && j.zoznam || []).map(z => z.cislo)))).catch(() => {}) }, [items])
  const [newModal, setNewModal] = useState(false)
  const [editModal, setEditModal] = useState(null)  // null | project object
  const [listHidden, setListHidden] = useState(() => { try { return localStorage.getItem('zk_list_hidden') === '1' } catch(_) { return false } })
  const toggleList = () => setListHidden(h => { const n = !h; try { localStorage.setItem('zk_list_hidden', n ? '1' : '0') } catch(_) {}; return n })

  const openEdit = useCallback((project) => {
    if (!project) return
    setEditModal(project)
  }, [])

  // Breadcrumb
  useEffect(() => {
    const selected = items.find(x => x.id === selectedId)
    setTrail([
      { label: 'Matrix v2', onClick: () => navigate('/') },
      { label: 'Zákazky', onClick: () => navigate('/zakazky') },
      ...(selected ? [{ label: selected.name }] : [])
    ])
    return () => setTrail([])
  }, [setTrail, navigate, items, selectedId])

  // Fetch zákazky + customers (pre lookup mien)
  const reload = useCallback(async () => {
    setLoading(true)
    try {
      const [projs, custs] = await Promise.all([
        fetchAuthJSON('/api/projects'),
        fetchAuthJSON('/api/customers').catch(() => [])
      ])
      setItems(Array.isArray(projs) ? projs : [])
      setCustomers(Array.isArray(custs) ? custs : [])
    } catch (e) {
      toast.error(`Načítanie zákaziek zlyhalo: ${e.message}`)
    } finally {
      setLoading(false)
    }
  }, [toast])

  useEffect(() => { reload() }, [reload])

  // živé obnovenie zoznamu pri cudzej zmene (ústava 348 SSE) — TICHO, bez spinnera; preskočí ak práve načítavam
  useLiveRefresh(async () => {
    try {
      const [projs, custs] = await Promise.all([fetchAuthJSON('/api/projects'), fetchAuthJSON('/api/customers').catch(() => [])])
      setItems(Array.isArray(projs) ? projs : [])
      setCustomers(Array.isArray(custs) ? custs : [])
    } catch (_) {}
  }, () => !loading)

  // Reload customers, keď VyberPartnera (okno nového partnera) založí alebo použije partnera — PARTNER_KONTROLA_V1
  useEffect(() => {
    function onChange() { reload() }
    window.addEventListener('matrix-customers-changed', onChange)
    return () => window.removeEventListener('matrix-customers-changed', onChange)
  }, [reload])

  // Auto-scroll lavy zoznam na vybranu zakazku (ked user pouzije sipky / URL)
  useEffect(() => {
    if (!selectedId) return
    // Mensi delay aby react stihol re-render
    const t = setTimeout(() => {
      const el = document.querySelector(`[data-zakazka-id="${selectedId}"]`)
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
      }
    }, 50)
    return () => clearTimeout(t)
  }, [selectedId])

  // Customer lookup
  const custMap = useMemo(() => {
    const m = {}
    customers.forEach(c => { m[c.id] = c.name })
    return m
  }, [customers])

  // KPI — Aktívne + Pripravované (variant a operatívne)
  const kpi = useMemo(() => {
    const aktivne = items.filter(p => p.status === 'active')
    const dohodnute = items.filter(p => p.status === 'planned')
    return {
      aktivne: {
        count: aktivne.length,
        sum: aktivne.reduce((s, p) => s + (p.zmluva_hodnota || 0), 0)
      },
      dohodnute: {
        count: dohodnute.length,
        sum: dohodnute.reduce((s, p) => s + (p.zmluva_hodnota || 0), 0)
      }
    }
  }, [items])

  // ZAKAZKY_HLADAJ_ID_V1 (Mirko 30. 10. 2026, Hotel Koral Z260098): zhoda s hľadaním — číslo Z na karte len s písmenom Z
  // (číslo bez Z je číslo MKsoftu; „260083“ = Koral v MKsofte, nie Tesla Z260083), MKsoft č. aj z mksoft_cislo, partner bez diakritiky
  const sediHladanie = useCallback((p, q) => hladaj((p.name || ''), q)
    || (/^\s*z/i.test(q) && hladaj(String(p.id || ''), q))
    || hladaj((p.zakazka_code || ''), q)
    || hladaj((p.mksoft_cislo || ''), q)
    || hladaj((p.mksoft_cisla_dalsie || ''), q)   // ZAKAZKA_CISLA_V1: aj ďalšie čísla zákazky
    || hladaj((p.site_address || ''), q)
    || hladaj((custMap[p.customerId] || ''), q), [custMap])

  // Filter + Sort (Prebieha hore, Ukoncene dole; v ramci skupiny najnovsie zmenene hore)
  const filtered = useMemo(() => {
    const statusOrder = { active: 0, planned: 1, done: 2 }
    return items.filter(p => {
      // zakazky_ui_v1: archív patrí pod svoj vlastný štítok, nie medzi „Všetky" — tam zavadzia.
      if (filterStatus === 'nesparovane') { if (String(p.zakazka_code || p.mksoft_cislo || '').trim()) return false; if (p.status === 'archived') return false }
      else if (filterStatus === 'all') { if (p.status === 'archived') return false }
      else if (p.status !== filterStatus) return false
      if (search.trim()) return sediHladanie(p, search)   // ZAKAZKY_HLADAJ_ID_V1
      return true
    }).sort((a, b) => {
      const sa = statusOrder[a.status] ?? 99
      const sb = statusOrder[b.status] ?? 99
      if (sa !== sb) return sa - sb
      // V ramci rovnakeho statusu: najnovsie zmenene/vytvorene hore
      const ta = a.updated_at || a.created_at || ''
      const tb = b.updated_at || b.created_at || ''
      return tb.localeCompare(ta)
    })
  }, [items, search, filterStatus, sediHladanie])

  // ZAKAZKY_HLADAJ_ID_V1: vo zvolenom filtri nič, ale hľadanie sedí na zákazku v inom stave (Hotel Koral = Dohodnuté pri filtri Prebieha)
  const mimoFiltra = useMemo(() => {
    if (!search.trim() || filtered.length) return null
    const po = {}
    for (const p of items) if (sediHladanie(p, search)) { const k = p.status || 'planned'; po[k] = (po[k] || 0) + 1 }
    const kluce = Object.keys(po)
    if (!kluce.length) return null
    return { text: kluce.map(k => ((STATUSES.find(x => x.key === k) || {}).label || k) + ' ' + po[k]).join(', '), filter: kluce.every(k => k === 'archived') ? 'archived' : 'all' }
  }, [items, search, filtered, sediHladanie])

  // Klávesová navigácia zoznamu — zdieľaný hook (ústava 54.2, 56.5)
  useListKeyboard({
    items: filtered,
    selectedId,
    onSelect: (id) => { confirmLeave().then(ok => { if (ok) navigate(`/zakazky/${id}`) }) },
    onOpen: (row) => openEdit(row),
    enabled: !newModal && !editModal,
  })
  // pamäť pozície — filter + hľadanie + scroll (ústava 53.3)
  useEffect(() => { pos.setFilter({ status: filterStatus, search }) }, [filterStatus, search, pos.setFilter])
  useEffect(() => {
    if (!loading && listRef.current) pos.restoreScroll(listRef.current)
  }, [loading])  // eslint-disable-line react-hooks/exhaustive-deps

  // Skratky
  useShortcuts(useMemo(() => ([
    { keys: 'alt+n',  label: 'Nová zákazka', scope: 'Zákazky', handler: () => setNewModal(true) },
    { keys: '/',      label: 'Hľadať',       scope: 'Zákazky', handler: () => {
      const el = document.querySelector('[data-zakazky-search]')
      if (el) el.focus()
    }, preventDefault: true }
  ]), []))

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm, height: '100%', minHeight: 0 }}>   {/* zakazky_plocha_v1: celá výška plochy */}

      {/* HLAVICKA + KPI — nad oboma stĺpcami */}
      <div>
        {/* zakazky_plocha_v1 (Mirko 20. 10.: jeden rad, KPI do filtrov): jeden tenký rad nad prácou */}
        <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap', background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: `4px ${SPACE.md}px`, minHeight: 36 }}>
          <h1 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra, color: COLORS.base }}>Zákazky</h1>
          <HelpHint section="23" text="**Čo tu vidíš:** zoznam všetkých stavieb firmy — vľavo karty, vpravo detail tej vybranej. Dáta idú z trasy /api/projects (tabuľka projects), meno zákazníka dopĺňa /api/customers.

**Prečo:** zákazka je nádoba, na ktorú sa viaže všetko ostatné — výmery, súpis prác, doklady, denník, mzdy a zisk; bez karty zákazky nemá doklad kam ísť.

**Kam to ide:** „+ Nová zákazka“ založí riadok v tabuľke projects a Matrix pridelí vlastné **Z-číslo** z ročného radu; účtovné **číslo zákazky dáva MKsoft** a Matrix ho len číta — zelený štítok = číslo je zapísané a v zozname z MKsoftu sedí, červený = bez čísla, žltý = číslo je zapísané, ale v zozname z MKsoftu sa nenašlo.

**Čo tu NEHĽADAJ:** sumy v dvoch pásikoch nahore nie sú výkaz výmer ani vyfakturované peniaze — je to hodnota zo zmluvy o dielo a dnes ju má vyplnených 19 zo 123 zákaziek, takže počet pri „Prebieha“ a suma pod ním hovoria o rôznom počte stavieb. **Stav sa tu nemení** — Začať, Ukončiť a Otvoriť robí len okno Termíny (⋮ pri riadku alebo karta Audit), v okne Upraviť pole Stav vôbec nie je a Zmazať zoznam neponúka." />   {/* hinty_v1 */}
          <span style={{ color: COLORS.muted, fontSize: TYPO.sizes.base }}>
            {loading ? 'Načítavam…' : `${items.length} celkom · ${filtered.length} zobrazených`}
          </span>
          <NesparovaneFA />{/* PRIJMY_ZAKAZKA_V1 */}
          <div style={{ flex: 1 }} />
          <ExportMenu
            data={filtered}
            filename={`zakazky-${todayLocal()}`}
            title="Zákazky"
            columns={[
              { key: 'id', label: 'ID' },
              { key: 'name', label: 'Názov' },
              { key: 'customer_name', label: 'Zákazník' },
              { key: 'status', label: 'Stav' },
              { key: 'site_address', label: 'Adresa stavby' },
              { key: 'total_budget', label: 'VV' },
            ]}
          />
          <BtnAdd onClick={() => setNewModal(true)} title="Alt+N">+ Nová zákazka</BtnAdd>
        </div>
        {/* zakazky_plocha_v1: KPI karty Prebieha/Dohodnuté zrušené — počet a suma ZoD sú vo filtroch zoznamu */}
      </div>

      {/* MASTER-DETAIL: vľavo zoznam, vpravo detail */}
      <div style={{ display: 'flex', gap: SPACE.md, flex: 1, minHeight: 0 }}>

        {/* ── ĽAVÝ PANEL — zoznam ─────────────────────────────── */}
        <div style={{
          width: 300,
          flexShrink: 0,
          background: COLORS.bg,
          border: `1px solid ${COLORS.line}`,
          borderRadius: RADIUS.lg,
          display: listHidden ? 'none' : 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          {/* search */}
          <div style={{ padding: SPACE.sm, borderBottom: `1px solid ${COLORS.line}`, position: 'relative' }}>
            <input
              data-zakazky-search
              type="text"
              placeholder="Hľadať (stlač /)…"
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{
                width: '100%',
                padding: '6px 28px 6px 10px',
                fontSize: TYPO.sizes.base,
                fontFamily: TYPO.family,
                border: `1px solid ${COLORS.line}`,
                borderRadius: RADIUS.md,
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
            {search && (   /* ZAKAZKY_HLADAJ_ID_V1: zrušiť hľadanie, kurzor ostane v políčku */
              <button type="button" onClick={e => { setSearch(''); const i = e.currentTarget.parentNode.querySelector('input'); if (i) i.focus() }} onKeyDown={e => e.stopPropagation()} title="Zrušiť hľadanie" aria-label="Zrušiť hľadanie"
                style={{ position: 'absolute', right: SPACE.sm + 4, top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'transparent', color: COLORS.muted, cursor: 'pointer', fontSize: 16, lineHeight: 1, padding: '0 4px' }}>×</button>
            )}
          </div>
          {/* filter chips */}
          <FilterChips options={STATUSES.map(o => o.key === 'active' ? { ...o, label: o.label + ' · ' + kpi.aktivne.count + ' · ' + kratkaSuma(kpi.aktivne.sum) } : o.key === 'planned' ? { ...o, label: o.label + ' · ' + kpi.dohodnute.count + ' · ' + kratkaSuma(kpi.dohodnute.sum) } : o)} value={filterStatus} onChange={setFilterStatus} />   {/* zakazky_plocha_v1: súčty vo filtroch */}
          {terminyAkcia && <TerminyAkciaOkno project={terminyAkcia.project} akcia={terminyAkcia.akcia} open onClose={() => setTerminyAkcia(null)} onChanged={() => reload()} />}
          {parovat && <MksoftParovanieOkno project={parovat} open onClose={() => setParovat(null)} onChanged={() => { setParovat(null); reload() }} />}
          {/* list */}
          <div
            ref={listRef}
            onScroll={e => pos.saveScroll(e.currentTarget.scrollLeft, e.currentTarget.scrollTop)}
            style={{ flex: 1, overflow: 'auto', outline: 'none', padding: 6 }}
          >
            {loading ? (
              <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Načítavam…</div>
            ) : filtered.length === 0 ? (
              <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                {items.length === 0 ? 'Žiadne zákazky.' : 'Žiadne zákazky podľa filtra.'}
                {mimoFiltra && (   /* ZAKAZKY_HLADAJ_ID_V1 */
                  <div style={{ marginTop: SPACE.sm, color: COLORS.text }}>
                    Hľadanie našlo v inom stave: {mimoFiltra.text} — <span role="button" tabIndex={0} onClick={() => setFilterStatus(mimoFiltra.filter)} onKeyDown={e => { e.stopPropagation(); if (e.key === 'Enter') setFilterStatus(mimoFiltra.filter) }} style={{ color: COLORS.brand, cursor: 'pointer', fontWeight: 600 }}>zobraziť</span>
                  </div>
                )}
              </div>
            ) : filtered.map(p => {
              const isSelected = p.id === selectedId
              const stripCol = (STATUSES.find(x => x.key === (p.status || 'planned')) || { color: COLORS.muted }).color   // zakazky_ui_v1
              return (
                <div
                  key={p.id}
                  data-zakazka-id={p.id}
                  onClick={() => { confirmLeave().then(ok => { if (ok) navigate(`/zakazky/${p.id}`) }) }}
                  onDoubleClick={() => openEdit(p)}
                  style={{
                    padding: '8px 10px',
                    marginBottom: 6,
                    cursor: 'pointer',
                    background: COLORS.bg,
                    borderTop: `1px solid ${isSelected ? COLORS.nav : COLORS.line}`,
                    borderRight: `1px solid ${isSelected ? COLORS.nav : COLORS.line}`,
                    borderBottom: `1px solid ${isSelected ? COLORS.nav : COLORS.line}`,
                    borderLeft: `4px solid ${stripCol}`,
                    borderRadius: RADIUS.lg,
                    boxShadow: isSelected ? `0 0 0 1px ${COLORS.nav}` : '0 1px 2px rgba(0,0,0,0.05)'
                  }}
                  title="1× klik = select · 2× klik = upraviť"
                  onMouseEnter={e => { if (!isSelected) e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.12)' }}
                  onMouseLeave={e => { if (!isSelected) e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)' }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 6 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{
                        fontSize: TYPO.sizes.sm,
                        fontWeight: isSelected ? TYPO.weights.bold : TYPO.weights.semibold,
                        color: isSelected ? COLORS.nav : COLORS.text,
                        whiteSpace: 'normal', wordBreak: 'break-word'
                      }}>{p.name}</div>
                      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono, marginTop: 2 }}>
                        {p.id} <StitokMKsoft kod={String(p.zakazka_code || p.mksoft_cislo || '').trim()} znamy={!mkZname.size || mkZname.has(String(p.zakazka_code || p.mksoft_cislo || '').trim())} />
                      </div>
                      {custMap[p.customerId] && (
                        <div style={{
                          fontSize: TYPO.sizes.xs,
                          color: COLORS.muted,
                          marginTop: 2,
                          whiteSpace: 'normal', wordBreak: 'break-word'
                        }}>{custMap[p.customerId]}</div>
                      )}
                    </div>
                    <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4 }}
                      onClick={e => e.stopPropagation()}>
                      {statusBadge(p.status)}
                      <RowMenu actions={[
                        { key: 'edit', label: 'Upraviť', onClick: () => openEdit(p) },
                        { key: 'mksoft', label: String(p.zakazka_code || p.mksoft_cislo || '').trim() ? 'Zmeniť spárovanie s MKsoftom' : 'Spárovať s MKsoftom', onClick: () => setParovat(p) },
                        { key: 'vymery', label: 'Zadať výmery', onClick: () => navigate(`/zakazky/${p.id}?tab=vymery`) },
                        { key: 'supis', label: 'Súpis prác', onClick: () => navigate(`/zakazky/${p.id}?tab=supis`) },
                        { key: 'email', label: 'Odoslať e-mailom', onClick: () => {
                          const subj = encodeURIComponent(`Zákazka ${p.zakazka_code || p.id} — ${p.name}`)
                          const body = encodeURIComponent(`Dobrý deň,\n\ninformácie k zákazke ${p.name} (${p.zakazka_code || p.id}).\n\nS pozdravom,\nKAMIR s.r.o.`)
                          window.location.href = `mailto:?subject=${subj}&body=${body}`
                        } },
                        // zakazky_ui_v1 (13. 10. 2026): kópia otvárala okno ÚPRAVY s prázdnym id — ukladalo by sa
                        // na /api/projects/undefined. Teraz otvorí okno Nová zákazka predvyplnené podľa pôvodnej;
                        // číslo jej pridelí ročný rad pri uložení, nekopíruje sa (zakazky_rad_v1).
                        { key: 'copy', label: 'Vytvoriť kópiu', onClick: () => setNewModal({ predvyplnene: {
                          name: (p.name || '') + ' (kópia)', customerId: p.customerId || '', segment: p.segment || 'firma',
                          type: p.type || 'omietky', site_address: p.site_address || '', majster: p.majster || '',
                          fakturacia: p.fakturacia || '', status: 'planned',
                        } }) },
                        // ukoncit_v1 (28. 9. 2026): stav sa mení len cez Termíny (23.2.A) — dátum, kontroly, RD vklad, zmenové listy
                        { key: 'ukoncit', label: p.status === 'done' ? 'Otvoriť (Prebieha)' : p.status === 'planned' ? 'Začať zákazku' : 'Ukončiť zákazku',
                          danger: p.status === 'active',
                          onClick: () => setTerminyAkcia({ project: p, akcia: p.status === 'done' ? 'otvorit' : p.status === 'planned' ? 'zacat' : 'ukoncit' }) },
                      ]} />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          {/* status bar */}
          <div style={{
            padding: '6px 12px',
            borderTop: `1px solid ${COLORS.line}`,
            fontSize: TYPO.sizes.xs,
            color: COLORS.muted,
            background: COLORS.bgSoft
          }}>
            ↑↓ select · Enter / 2× klik upraviť · / hľadať · Alt+N nová
          </div>
        </div>

        <div onClick={toggleList} title={listHidden ? 'Zobraziť zoznam zákaziek' : 'Skryť zoznam — plná šírka pre detail/Výmery'} style={{ width: 20, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: COLORS.brand, fontWeight: 800, fontSize: 14, userSelect: 'none' }}>{listHidden ? '»' : '«'}</div>

        {/* ── PRAVÝ PANEL — detail ─────────────────────────────── */}
        <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
          {selectedId ? (
            <DetailPane
              id={selectedId}
              custMap={custMap}
              onReload={reload}
              onEdit={openEdit}
            />
          ) : (
            <EmptyPane filtered={filtered} listHidden={listHidden} onShowList={toggleList} />
          )}
        </div>

      </div>

      {/* MODALY */}
      {newModal && (
        <NovaZakazkaV3
          open={newModal}
          predvyplnene={(newModal && newModal.predvyplnene) || {}}
          customers={customers}
          onClose={() => setNewModal(false)}
          onCreated={(newProj, info) => {
            setNewModal(false)
            reload()
            navigate(`/zakazky/${newProj.id}`)
            if (info && info.sparovane) return
            toast.success(`Zákazka ${newProj.id} (${newProj.name}) založená` + (info && info.doklady ? ` · priradených dokladov: ${info.doklady}` : ''))
            setVratit({ id: newProj.id, name: newProj.name, do: Date.now() + 120000 })   // Vrátiť do 2 min (53.4)
          }}
        />
      )}
      {/* zakazky_ui_v1: lišta zmizne sama — bez tohto sa dve minúty kontrolovali len pri prekreslení */}
      {vratit && vratit.do > Date.now() && (
        <div style={{ position: 'fixed', left: '50%', bottom: 18, transform: 'translateX(-50%)', zIndex: 60, background: COLORS.text, color: '#fff', borderRadius: RADIUS.lg, padding: '8px 14px', display: 'flex', gap: 12, alignItems: 'center', fontSize: TYPO.sizes.sm, boxShadow: '0 6px 20px rgba(0,0,0,.25)' }}>
          <span>{vratit.typ === 'uprava' ? `Zákazka ${vratit.id} uložená.` : `Zákazka ${vratit.id} založená.`}</span>
          <button onClick={async () => {
            if (vratit.typ === 'uprava') {   // úprava: pošle späť len polia, ktoré som zmenil; ak ich medzitým zmenil niekto iný, odmietne (129.1)
              try {
                const cur = await fetchAuthJSON(`/api/projects/${vratit.id}`)
                const nz = (v) => (v === undefined || v === null) ? '' : String(v)
                const cudzie = Object.keys(vratit.nove || {}).filter(k => nz(cur[k]) !== nz(vratit.nove[k]))
                if (cudzie.length) throw new Error('polia medzitým zmenil niekto iný (' + cudzie.join(', ') + ')')
                const r = await fetchAuth(`/api/projects/${vratit.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...(vratit.stare || {}), updated_at: cur.updated_at }) })
                if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.message || j.error || ('HTTP ' + r.status)) }
                toast.success('Vrátené — zmeny zákazky ' + vratit.id + ' sú späť'); setVratit(null); reload()
              } catch (e) { toast.error('Vrátiť sa nepodarilo: ' + e.message) }
              return
            }
            // zakazky_ui_v1 (13. 10. 2026): najprv uvoľni číslo z MKsoftu a vráť doklady do Importov,
            // až potom archivuj. Bez toho si archivovaná karta číslo držala a tú istú zákazku už nešlo založiť znova.
            try { await fetchAuth('/api/mksoft-zakazky/odpojit', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ project_id: vratit.id }) }) } catch (_) {}
            try { const r = await fetchAuth(`/api/projects/${vratit.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status: 'archived' }) })
              if (!r.ok) throw new Error('PUT ' + r.status); toast.success('Vrátené — zákazka ' + vratit.id + ' je v archíve'); setVratit(null); reload(); navigate('/zakazky') } catch (e) { toast.error('Vrátiť sa nepodarilo: ' + e.message) }
          }} style={{ background: 'transparent', color: '#fbbf24', border: '1px solid #fbbf24', borderRadius: 8, padding: '3px 10px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Vrátiť (2 min)</button>
          <button onClick={() => setVratit(null)} style={{ background: 'transparent', color: '#fff', border: 0, cursor: 'pointer', fontSize: 16 }}>×</button>
        </div>
      )}
      {editModal && (
        <EditProjectModal
          open={!!editModal}
          project={editModal}
          customers={customers}
          user={user}
          onClose={() => setEditModal(null)}
          onAkcia={(a) => { const p = editModal; if (a === 'mksoft') { setEditModal(null); setParovat(p) } else if (a === 'karta') { setEditModal(null); navigate(`/zakazky/${p.id}`) } }}
          onSaved={(info) => {
            const code = editModal?.id || ''
            setEditModal(null)
            reload()
            toast.success(`Zákazka ${code} uložená` + (info && info.zmenene ? ` · zmenených polí: ${info.zmenene}` : ''))
            setVratit({ id: code, typ: 'uprava', stare: info && info.stare, nove: info && info.nove, do: Date.now() + 120000 })   // Vrátiť do 2 min (53.4)
          }}
        />
      )}
    </div>
  )
}

// ── KPI karta ─────────────────────────────────────────────────

// ── EmptyPane (žiadna selekcia) ────────────────────────────────
function EmptyPane({ filtered, listHidden, onShowList }) {   // ZAKAZKY_HLADAJ_ID_V1: listHidden
  return (
    <div style={{
      background: COLORS.bg,
      border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.lg,
      padding: SPACE.xxl,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: COLORS.muted,
      fontSize: TYPO.sizes.base
    }}>
      <div style={{ marginBottom: SPACE.md, color: COLORS.disabled }}><NavIcon name="point-left" size={48} /></div>
      {listHidden
        ? <div>Zoznam zákaziek je skrytý — <span role="button" tabIndex={0} onClick={onShowList} onKeyDown={e => { e.stopPropagation(); if (e.key === 'Enter') onShowList() }} style={{ color: COLORS.brand, cursor: 'pointer', fontWeight: 600 }}>zobraziť zoznam</span></div>
        : <div>{filtered.length > 0 ? 'Vyber zákazku zo zoznamu' : 'Žiadne zákazky v aktuálnom filtri'}</div>}
    </div>
  )
}

// ══════════════════════════════════════════════════════════════
// NEW PROJECT MODAL — Form → Confirm (ústava 12.0 bod 3)
// ══════════════════════════════════════════════════════════════
function NewProjectModal({ open, customers, onClose, onCreated }) {
  const toast = useToast()
  const initial = {
    name: '', customerId: '', status: 'planned', segment: 'firma', fakturacia: '',
    type: 'omietky', zakazka_code: '', zmluva_hodnota: '', contract_ref: '', nazov_stavby_zod: '', usek_realizacie: '',
    contract_date: '', site_address: '', google_maps_link: '', majster: '', notes: ''
  }
  const form = useDirtyState(initial)
  const updateField = (k, v) => form.setValue({ ...form.value, [k]: v })
  const [phase, setPhase] = useState('form')   // 'form' | 'confirm'
  const [saving, setSaving] = useState(false)
  const [errors, setErrors] = useState({})
  const [dirtyDialog, setDirtyDialog] = useState(false)
  const handleClose = () => { if (form.isDirty) setDirtyDialog(true); else onClose() }
  // indexovanie nespárovaných zápisov Rozpisu (ústava 10.3 — vlákno)
  const [unpairedWS, setUnpairedWS] = useState([])
  useEffect(() => {
    if (!open) return
    fetchAuth('/api/work-schedule')
      .then(r => r.json())
      .then(d => setUnpairedWS((Array.isArray(d) ? d : []).filter(w => !w.project_id && (w.project_name || '').trim())))
      .catch(() => {})
  }, [open])
  const unpairedNames = useMemo(
    () => [...new Set(unpairedWS.map(w => (w.project_name || '').trim()).filter(Boolean))],
    [unpairedWS])

  function validate() {
    const errs = {}
    if (!form.value.name.trim()) errs.name = 'Názov je povinný (sek. 22)'
    if (!form.value.customerId) errs.customerId = 'Zákazník je povinný'
    if (!form.value.segment) errs.segment = 'Segment je povinný'
    if (!form.value.fakturacia) errs.fakturacia = 'Fakturácia je povinná (jednorázová / opakujúca) — ústava'
    if (!form.value.site_address || !form.value.site_address.trim()) errs.site_address = 'Adresa (aspoň obec) je povinná — kvôli teplote v denníku'
    setErrors(errs)
    return Object.keys(errs).length === 0
  }

  function goConfirm() {
    if (validate()) { setPhase('confirm'); return }
    // Mirko 5.8.: tlačidlo nesmie vyzerať mŕtvo — povedz NAHLAS, čo chýba
    const errs = {}
    if (!form.value.name.trim()) errs.name = 'Názov'
    if (!form.value.customerId) errs.customerId = 'Zákazník'
    if (!form.value.segment) errs.segment = 'Segment'
    if (!form.value.fakturacia) errs.fakturacia = 'Fakturácia'
    if (!form.value.site_address || !form.value.site_address.trim()) errs.site_address = 'Adresa stavby (aspoň obec)'
    toast.error('Vyplň povinné polia: ' + Object.values(errs).join(', '))
  }

  async function doSave() {
    setSaving(true)
    try {
      const payload = { ...form.value }
      payload.zmluva_hodnota = SK.parse(String(payload.zmluva_hodnota)) || 0
      const r = await fetchAuth('/api/projects', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      if (r.status === 409) {
        const j = await r.json()
        toast.error(`${j.message} (ID: ${j.existingId})`)
        setPhase('form')
      } else if (!r.ok) {
        const j = await r.json().catch(() => ({}))
        toast.error(`Uloženie zlyhalo: ${j.error || r.status}`)
        setPhase('form')
      } else {
        const created = await r.json()
        // prepoj nespárované zápisy Rozpisu s rovnakým názvom (ústava 10.3 — vlákno)
        const toLink = unpairedWS.filter(w => (w.project_name || '').trim() === form.value.name.trim())
        for (const w of toLink) {
          try {
            await fetchAuth(`/api/work-schedule/${w.id}`, {
              method: 'PUT', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...w, project_id: created.id })
            })
          } catch (_) {}
        }
        if (toLink.length) toast.success(`Prepojených ${toLink.length} zápisov z Rozpisu`)
        onCreated(created)
        form.reset()
      }
    } catch (e) {
      toast.error(`Chyba: ${e.message}`)
    } finally {
      setSaving(false)
    }
  }

  const footer = phase === 'form' ? (
    <>
      <BtnGhost onClick={handleClose}>Zrušiť</BtnGhost>
      <BtnNav onClick={goConfirm}>Pokračovať na potvrdenie →</BtnNav>
    </>
  ) : (
    <>
      <BtnGhost onClick={() => setPhase('form')}>← Späť na úpravy</BtnGhost>
      <BtnAdd onClick={doSave} disabled={saving}>
        {saving ? 'Ukladám…' : '✓ Potvrdiť uloženie'}
      </BtnAdd>
    </>
  )

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={phase === 'form' ? 'Nová zákazka — krok 1: údaje' : 'Nová zákazka — krok 2: potvrdenie'}
      subtitle={phase === 'form' ? 'Vyplň údaje, potom Pokračuj na súhrn' : 'Skontroluj a potvrď — pred potvrdením sa NIČ neuloží (ústava 12.0)'}
      footer={footer}
      isDirty={form.isDirty}
      onDirtyClose={() => setDirtyDialog(true)}
    >
      {phase === 'form' && (
        <ProjectFormFields
          value={form.value}
          set={updateField}
          setMany={o => form.setValue({ ...form.value, ...o })}
          customers={customers}
          errors={errors}
          nameSuggestions={unpairedNames}
        />
      )}
      {phase === 'confirm' && (
        <ConfirmPhase value={form.value} customers={customers} mode="new" />
      )}
      <Modal.DirtyConfirm
        open={dirtyDialog}
        onSave={() => { setDirtyDialog(false); goConfirm() }}
        onContinue={() => setDirtyDialog(false)}
        onDiscard={() => { form.discard(); setDirtyDialog(false); onClose() }}
      />
    </Modal>
  )
}

// ── Form fields (zdielane medzi New + Edit) ────────────────────
// Pole Názov s našepkávačom nespárovaných zápisov Rozpisu (5c, ústava 10.3)
function ProjectNameField({ value, onChange, error, suggestions }) {
  const [open, setOpen] = useState(false)
  const q = (value || '').trim().toLowerCase()
  const matches = q && Array.isArray(suggestions)
    ? suggestions.filter(n => hladaj(n, q) && n.toLowerCase() !== q).slice(0, 6)
    : []
  return (
    <div style={{ position: 'relative' }}>
      <Input label="Názov zákazky *" value={value} error={error}
        placeholder="napr. Novák — Bratislava"
        onChange={v => { onChange(v); setOpen(true) }} />
      {open && matches.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 50,
          background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)', marginTop: 2, maxHeight: 220, overflowY: 'auto' }}>
          <div style={{ padding: '5px 9px', fontSize: TYPO.sizes.xs, color: COLORS.muted,
            borderBottom: `1px solid ${COLORS.lineSoft}`, background: COLORS.bg }}>
            Nespárované zápisy v Rozpise — vyber a po uložení sa prepoja:
          </div>
          {matches.map(n => (
            <div key={n} onClick={() => { onChange(n); setOpen(false) }}
              style={{ padding: '7px 9px', fontSize: TYPO.sizes.sm, cursor: 'pointer' }}
              onMouseEnter={e => { e.currentTarget.style.background = COLORS.hover }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent' }}>
              {n}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

const SK_PSC = {'košice':'040 01','prešov':'080 01','bratislava':'811 01','žilina':'010 01','nitra':'949 01','banská bystrica':'974 01','trnava':'917 01','trenčín':'911 01','martin':'036 01','poprad':'058 01','zvolen':'960 01','michalovce':'071 01','bardejov':'085 01','humenné':'066 01','vranov':'093 01','tovarné':'094 01','sabinov':'083 01','kežmarok':'060 01','stropkov':'091 01','svidník':'089 01','snina':'069 01','spišská nová ves':'052 01','chminianske jakubovany':'082 33','kechnec':'044 58'}
function ProjectFormFields({ value, set, setMany, customers, errors = {}, nameSuggestions }) {
  const [majstri, setMajstri] = useState([])
  useEffect(() => { fetchAuthJSON('/api/employees').then(e => setMajstri((Array.isArray(e)?e:[]).filter(x => ['majster','majiteľ','technik'].includes((x.role||'').toLowerCase())))).catch(()=>{}) }, [])
  const pscMatch = (() => { const a=(value.site_address||'').toLowerCase().trim(); if(!a) return null; for (const [c,p] of Object.entries(SK_PSC)) if (a.includes(c)) return {city:c,psc:p}; return null })()
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: SPACE.md }}>
      {nameSuggestions
        ? <ProjectNameField value={value.name} onChange={v => set('name', v)} error={errors.name} suggestions={nameSuggestions} />
        : <Input label="Názov zákazky *" value={value.name} onChange={v => set('name', v)} error={errors.name} placeholder="napr. Novák — Bratislava" />}
      <div style={{ gridColumn: '1 / -1' }}>
        <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, marginBottom: 4 }}>MKsoft zákazka — ponuka na spárovanie</div>
        <ParovanieMKsoft typ="zakazka" hodnota={String(value.zakazka_code || '').trim()} nazov={value.name} partnerId={value.customerId} kompakt
          onVyber={(kod, meta) => { const o = { zakazka_code: kod || '' }; if (meta && meta.mksoft) { if (!value.name && meta.mksoft.nazov) o.name = meta.mksoft.nazov; if (!value.customerId && meta.mksoft.zakaznik) o.customerId = String(meta.mksoft.zakaznik.id) } if (setMany) setMany(o); else set('zakazka_code', o.zakazka_code) }} />
      </div>

      <div>{/* PARTNER_KONTROLA_V1: spoločný VyberPartnera namiesto CustomerCombobox (0.J) */}
        <label style={{ display: 'block', fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, marginBottom: 4, color: COLORS.text }}>Zákazník *</label>
        <VyberPartnera value={value.customerId} onChange={v => set('customerId', v)} moznosti={customers.map(moznostPartnera)} error={!!errors.customerId} />
        {errors.customerId && <div style={{ color: COLORS.remove, fontSize: TYPO.sizes.xs, marginTop: 2 }}>{errors.customerId}</div>}
      </div>

      <div>
        <label style={{ display: 'block', fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, marginBottom: 4, color: COLORS.text }}>
          Segment *
        </label>
        <select
          value={value.segment || 'firma'}
          onChange={e => set('segment', e.target.value)}
          style={{
            width: '100%', padding: '6px 10px', fontSize: TYPO.sizes.base,
            fontFamily: TYPO.family, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
            background: COLORS.bg, outline: 'none', boxSizing: 'border-box'
          }}
        >
          {SEGMENTS.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
        </select>
        {errors.segment && (<div style={{ color: '#dc2626', fontSize: TYPO.sizes.xs, marginTop: 2 }}>{errors.segment}</div>)}
      </div>

      <div>
        <label style={{ display: 'block', fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, marginBottom: 4, color: COLORS.text }}>
          Fakturácia *
        </label>
        <select
          value={value.fakturacia || ''}
          onChange={e => set('fakturacia', e.target.value)}
          style={{
            width: '100%', padding: '6px 10px', fontSize: TYPO.sizes.base,
            fontFamily: TYPO.family, border: `1px solid ${errors.fakturacia ? '#dc2626' : COLORS.line}`, borderRadius: RADIUS.md,
            background: COLORS.bg, outline: 'none', boxSizing: 'border-box'
          }}
        >
          <option value="">— vyber —</option>
          <option value="jednorazova">Jednorázová (po vyliatí/dokončení → faktúra)</option>
          <option value="opakujuca">Opakujúca — priebežná (vlákno vylievaní)</option>
        </select>
        {errors.fakturacia && (
          <div style={{ color: '#dc2626', fontSize: TYPO.sizes.xs, marginTop: 2 }}>{errors.fakturacia}</div>
        )}
      </div>

      <div>
        <label style={{ display: 'block', fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, marginBottom: 4, color: COLORS.text }}>
          Stav
        </label>
        <select
          value={value.status || 'planned'}
          disabled
          title="Stav sa mení v karte Info › Termíny (Začať / Ukončiť) — ústava 23.2.A"
          onChange={e => set('status', e.target.value)}
          style={{
            width: '100%', padding: '6px 10px', fontSize: TYPO.sizes.base,
            fontFamily: TYPO.family, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
            background: COLORS.bg, outline: 'none', boxSizing: 'border-box'
          }}
        >
          {STATUSES.filter(s => s.key !== 'all' && s.key !== 'nesparovane').map(s => (
            <option key={s.key} value={s.key}>{s.icon} {s.label}</option>
          ))}
        </select>
      </div>

      <div>
        <label style={{ display: 'block', fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, marginBottom: 4, color: COLORS.text }}>
          Typ prác
        </label>
        <select
          value={value.type || 'omietky'}
          onChange={e => set('type', e.target.value)}
          style={{
            width: '100%', padding: '6px 10px', fontSize: TYPO.sizes.base,
            fontFamily: TYPO.family, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
            background: COLORS.bg, outline: 'none', boxSizing: 'border-box'
          }}
        >
          {TYPES.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>

      <Input label="ZoD číslo" value={value.contract_ref} onChange={v => set('contract_ref', v)} placeholder="napr. ZoD-2026-014" />
      <Input label="Názov stavby podľa ZoD" value={value.nazov_stavby_zod} onChange={v => set('nazov_stavby_zod', v)} placeholder="oficiálny názov stavby zo Zmluvy o dielo — čerpajú ho TP a oficiálne dokumenty" />
      <Input label="Miesto realizácie (objekt, podlažia)" value={value.usek_realizacie} onChange={v => set('usek_realizacie', v)} placeholder="napr. Objekt A, 1. – 8. NP — vypíše sa na titulke TP a oficiálnych dokumentov" />
      <Input label="Dátum ZoD" type="date" value={value.contract_date} onChange={v => set('contract_date', v)} />
      <NumberInput label="Hodnota ZoD (€)" value={value.zmluva_hodnota} onChange={v => set('zmluva_hodnota', v)} placeholder="0,00" />
      <div>
        <label style={{ display:'block', fontSize:TYPO.sizes.sm, fontWeight:TYPO.weights.semibold, marginBottom:4, color:COLORS.text }}>Majster</label>
        <SearchableSelect value={value.majster} onChange={v => set('majster', v)} allowCreate emptyLabel="—" placeholder="Vyber majstra / majiteľa…"
          options={majstri.map(m => { const n=((m.firstName||'')+' '+(m.lastName||'')).trim(); return { value:n, label:n+(((m.role||'').toLowerCase()==='majiteľ')?' (majiteľ)':'') } })} />
      </div>

      <div style={{ gridColumn: '1 / -1' }}>
        {/* CP_OTVOR_V1: miesto stavby v bunkách ako NovaZakazkaV3 (23.Z) — jeden riadok site_address sa poskladá z buniek */}
        <AdresaBunky nadpis="Miesto stavby" hodnota={value} disabled={!setMany}
          zmen={(o) => { if (setMany) setMany({ ...o, site_address: adresaSloz(o) }) }} />
        {errors.site_address && <div style={{ color: COLORS.remove, fontSize: TYPO.sizes.xs, marginTop: 2 }}>{errors.site_address}</div>}
        {pscMatch && <div style={{ fontSize:TYPO.sizes.xs, color:'#b45309', marginTop:3 }}>{pscMatch.city.charAt(0).toUpperCase()+pscMatch.city.slice(1)} → PSČ {pscMatch.psc} (pre teplotu v denníku)</div>}
      </div>
      <Input label="Google Maps link" value={value.google_maps_link} onChange={v => set('google_maps_link', v)} placeholder="https://maps.app.goo.gl/…" />

      <div style={{ gridColumn: '1 / -1' }}>
        <Textarea label="Poznámka" value={value.notes} onChange={v => set('notes', v)} rows={3} placeholder="dodatočné info…" />
      </div>
    </div>
  )
}

// ── Confirm phase (ústava 12.0 bod 3 + sek. 53.8 DIFF) ─────────
function ConfirmPhase({ value, customers, mode = 'new', original = null }) {
  const isEdit = mode === 'edit' && original
  const cust = customers.find(c => c.id === value.customerId)
  const origCust = isEdit ? customers.find(c => c.id === original.customerId) : null
  // zakazky_ui_v1: neznámy stav sa ukáže tak, ako je zapísaný — nie ako „Dohodnuté"
  const status = STATUSES.find(s => s.key === value.status) || { label: String(value.status || '—'), color: COLORS.muted, bg: COLORS.bgSoft }
  const origStatus = isEdit ? (STATUSES.find(s => s.key === original.status) || { label: String(original.status || '—'), color: COLORS.muted, bg: COLORS.bgSoft }) : null

  const fmt = v => (v === null || v === undefined || v === '') ? '—' : String(v)
  const eur = v => v ? SK.eur(SK.parse(String(v)) || 0) : '—'

  // Polia s display hodnotami pre new aj original
  const FIELDS = [
    { k: 'name',           l: 'Názov',          newV: value.name,       oldV: original?.name,           bold: true },
    { k: 'zakazka_code',   l: 'Číslo zákazky',  newV: value.zakazka_code, oldV: original?.zakazka_code, mono: true },
    { k: 'customerId',     l: 'Zákazník',       newV: cust ? cust.name : value.customerId, oldV: origCust ? origCust.name : original?.customerId },
    { k: 'segment',        l: 'Segment',        newV: value.segment === 'rd' ? 'RD' : 'Firma', oldV: original?.segment === 'rd' ? 'RD' : 'Firma', cmpRaw: true, cmpA: value.segment, cmpB: original?.segment },
    { k: 'fakturacia',     l: 'Fakturácia',     newV: value.fakturacia === 'opakujuca' ? 'Opakujúca (priebežná)' : value.fakturacia === 'jednorazova' ? 'Jednorázová' : '—', oldV: original?.fakturacia === 'opakujuca' ? 'Opakujúca (priebežná)' : original?.fakturacia === 'jednorazova' ? 'Jednorázová' : '—', cmpRaw: true, cmpA: value.fakturacia, cmpB: original?.fakturacia },
    { k: 'status',         l: 'Stav',           newV: `${status.icon} ${status.label}`, oldV: origStatus ? `${origStatus.icon} ${origStatus.label}` : '—', cmpRaw: true, cmpA: value.status, cmpB: original?.status },
    { k: 'type',           l: 'Typ prác',       newV: value.type,       oldV: original?.type },
    { k: 'contract_ref',   l: 'ZoD číslo',      newV: value.contract_ref, oldV: original?.contract_ref },
    { k: 'nazov_stavby_zod', l: 'Názov stavby (ZoD)', newV: value.nazov_stavby_zod, oldV: original?.nazov_stavby_zod },
    { k: 'usek_realizacie', l: 'Miesto realizácie', newV: value.usek_realizacie, oldV: original?.usek_realizacie },
    { k: 'contract_date',  l: 'Dátum ZoD',      newV: value.contract_date, oldV: original?.contract_date },
    { k: 'zmluva_hodnota', l: 'Hodnota ZoD',    newV: eur(value.zmluva_hodnota), oldV: eur(original?.zmluva_hodnota), cmpRaw: true, cmpA: SK.parse(String(value.zmluva_hodnota)) || 0, cmpB: original?.zmluva_hodnota || 0 },
    { k: 'majster',        l: 'Majster',        newV: value.majster,    oldV: original?.majster },
    { k: 'site_address',   l: 'Adresa stavby',  newV: value.site_address, oldV: original?.site_address },
    { k: 'google_maps_link', l: 'Google Maps',  newV: value.google_maps_link, oldV: original?.google_maps_link }
  ]

  const changedCount = isEdit
    ? FIELDS.filter(f => f.cmpRaw ? String(f.cmpA ?? '') !== String(f.cmpB ?? '') : String(f.newV ?? '') !== String(f.oldV ?? '')).length
    : 0

  return (
    <>
      {/* BANNER */}
      <div style={{
        padding: SPACE.md,
        background: COLORS.addBg,
        border: `1px solid ${COLORS.add}`,
        borderRadius: RADIUS.md,
        marginBottom: SPACE.lg,
        color: COLORS.text,
        fontSize: TYPO.sizes.sm
      }}>
        <div style={{ fontWeight: TYPO.weights.bold, marginBottom: 4, color: COLORS.add }}>Pred potvrdením skontroluj:</div>
        {isEdit ? (
          <>
            <strong>Zmeny sa uložia</strong> k existujúcej zákazke <strong>{original.name}</strong> (<code style={{ fontFamily: TYPO.mono }}>{original.id}</code>).
            {' '}<strong>Žiadne dáta sa zatiaľ nezmenili</strong> — uloženie nastane až po stlačení „✓ Potvrdiť uloženie".
            {changedCount > 0 && (
              <div style={{ marginTop: 6, color: COLORS.warn, fontWeight: TYPO.weights.semibold }}>
                Zmenené polia: <strong>{changedCount}</strong> (žlto zvýraznené v tabuľke nižšie)
              </div>
            )}
            {changedCount === 0 && (
              <div style={{ marginTop: 6, color: COLORS.muted }}>
                Žiadne polia neboli zmenené — môžeš ísť späť a upraviť, alebo zavrieť.
              </div>
            )}
          </>
        ) : (
          <><strong>Nová zákazka vznikne</strong> s nasledujúcimi údajmi. <strong>Žiadne dáta sa zatiaľ neuložili</strong> — uloženie nastane až po stlačení „✓ Potvrdiť uloženie".</>
        )}
      </div>

      {/* TABULKA polí */}
      <div style={{
        background: COLORS.bg,
        border: `1px solid ${COLORS.line}`,
        borderRadius: RADIUS.lg,
        padding: SPACE.lg
      }}>
        {isEdit ? (
          <>
            {/* Header DIFF */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '180px 1fr 1fr',
              gap: 4,
              paddingBottom: SPACE.xs,
              marginBottom: SPACE.xs,
              borderBottom: `2px solid ${COLORS.line}`,
              fontSize: TYPO.sizes.xs,
              fontWeight: TYPO.weights.semibold,
              color: COLORS.muted,
              textTransform: 'uppercase',
              letterSpacing: '0.04em'
            }}>
              <div>Pole</div>
              <div>Pôvodne</div>
              <div>Nová hodnota</div>
            </div>

            {/* Riadky DIFF — sek. 53.8 zlte zvyraznene zmeny */}
            {FIELDS.map((f, i) => {
              const changed = f.cmpRaw
                ? String(f.cmpA ?? '') !== String(f.cmpB ?? '')
                : String(f.newV ?? '') !== String(f.oldV ?? '')
              return (
                <div key={i} style={{
                  display: 'grid',
                  gridTemplateColumns: '180px 1fr 1fr',
                  gap: 4,
                  padding: '4px 0',
                  borderBottom: i < FIELDS.length - 1 ? `1px solid ${COLORS.lineSoft}` : 'none',
                  background: changed ? 'rgba(245,158,11,0.10)' : 'transparent',
                  borderRadius: changed ? RADIUS.sm : 0,
                  paddingLeft: changed ? 6 : 0,
                  marginLeft: changed ? -6 : 0,
                  paddingRight: changed ? 6 : 0,
                  marginRight: changed ? -6 : 0
                }}>
                  <div style={{
                    color: COLORS.muted,
                    fontSize: TYPO.sizes.sm,
                    fontWeight: changed ? TYPO.weights.semibold : TYPO.weights.normal
                  }}>
                    {changed && <span style={{ color: COLORS.warn, marginRight: 4 }}>●</span>}
                    {f.l}
                  </div>
                  <div style={{
                    color: changed ? COLORS.muted : COLORS.text,
                    fontFamily: f.mono ? TYPO.mono : 'inherit',
                    fontSize: TYPO.sizes.sm,
                    textDecoration: changed ? 'line-through' : 'none',
                    whiteSpace: 'pre-wrap'
                  }}>{fmt(f.oldV)}</div>
                  <div style={{
                    color: COLORS.text,
                    fontFamily: f.mono ? TYPO.mono : 'inherit',
                    fontSize: TYPO.sizes.sm,
                    fontWeight: changed ? TYPO.weights.bold : (f.bold ? TYPO.weights.semibold : TYPO.weights.normal),
                    whiteSpace: 'pre-wrap'
                  }}>
                    {changed && <span style={{ color: COLORS.warn, marginRight: 4 }}>→</span>}
                    {fmt(f.newV)}
                  </div>
                </div>
              )
            })}
          </>
        ) : (
          /* NEW mode — 2 stlpce */
          <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', gap: 4 }}>
            {FIELDS.map((f, i) => (
              <React.Fragment key={i}>
                <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm, padding: '4px 0' }}>{f.l}</div>
                <div style={{
                  color: COLORS.text,
                  fontFamily: f.mono ? TYPO.mono : 'inherit',
                  fontWeight: f.bold ? TYPO.weights.semibold : TYPO.weights.normal,
                  fontSize: TYPO.sizes.sm,
                  padding: '4px 0'
                }}>{fmt(f.newV)}</div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </>
  )
}

// ══════════════════════════════════════════════════════════════
// EDIT PROJECT MODAL — Form → Confirm + DIFF + useLock (sek. 53.7)
// ══════════════════════════════════════════════════════════════
function EditProjectModal({ open, project, customers, user, onClose, onSaved, onAkcia }) {
  // Zámok (sek. 53.7) — pri cudzej editácii len náhľad; inak spoločný FormularV3 (EditZakazkaV3)
  const { lockInfo, acquired } = useLock(open ? 'project' : null, open ? project.id : null, user)
  const isLocked = !acquired && !!lockInfo?.by
  if (isLocked) {
    return (
      <Modal open={open} onClose={onClose} title={`Editácia zamknutá — ${project.name}`} subtitle={`Edituje teraz: ${lockInfo?.by_name || lockInfo?.by}`} footer={<BtnGhost onClick={onClose}>Zavrieť</BtnGhost>}>
        <LockedView lockInfo={lockInfo} project={project} customers={customers} />
      </Modal>
    )
  }
  return <EditZakazkaV3 open={open} project={project} customers={customers} user={user} onClose={onClose} onSaved={onSaved} onAkcia={onAkcia} />
}



// CreatePartnerInline (adresa v jednom riadku) zmazané — nového partnera zakladá spoločné components/NoviCustomerDialog.jsx
// s adresou v bunkách (AdresaBunky, ústava 23.Z.1, 0.J).

// ── Locked view (sek. 53.7.2) ───────────────────────────────────
function LockedView({ lockInfo, project, customers }) {
  return (
    <div>
      <div style={{
        padding: SPACE.md,
        background: COLORS.removeBg,
        border: `2px solid ${COLORS.remove}`,
        borderRadius: RADIUS.md,
        marginBottom: SPACE.md,
        textAlign: 'center'
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 4, color: COLORS.remove }}><NavIcon name="lock" size={32} /></div>
        <div style={{ fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.bold, color: COLORS.remove }}>
          Edituje {lockInfo?.by_name || lockInfo?.by}
        </div>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 4 }}>
          Zatvor a skús znova o chvíľu.
        </div>
      </div>
      <div style={{ opacity: 0.7 }}>
        <ProjectFormFields
          value={{
            name: project.name || '', customerId: project.customerId || '', status: project.status || 'planned',
            segment: project.segment || 'firma', fakturacia: project.fakturacia || '', type: project.type || 'omietky',
            zakazka_code: project.zakazka_code || '', zmluva_hodnota: project.zmluva_hodnota || '',
            contract_ref: project.contract_ref || '', nazov_stavby_zod: project.nazov_stavby_zod || '', usek_realizacie: project.usek_realizacie || '', contract_date: project.contract_date || '',
            site_address: project.site_address || '', google_maps_link: project.google_maps_link || '',
            ...((project.adresa_ulica || project.adresa_obec || project.adresa_psc) ? { adresa_ulica: project.adresa_ulica || '', adresa_cislo: project.adresa_cislo || '', adresa_psc: project.adresa_psc || '', adresa_obec: project.adresa_obec || '', adresa_stat: project.adresa_stat || '' } : adresaRozlozStavba(project.site_address || '')),
            majster: project.majster || '', notes: project.notes || ''
          }}
          set={() => {}}
          customers={customers}
        />
      </div>
    </div>
  )
}
